import {ACTIONS} from "../01-actions/adminProducts"

const initialState = {
    status: null,
    products: [],
    featuredProducts: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case ACTIONS.FEATURED_PRODUCTS_LOADING:
            return {
                ...state,
                status: action.type,
            };
        case ACTIONS.FEATURED_PRODUCTS_LOADED:
            return {
                ...state,
                status: action.type,
                featuredProducts: action.data.products,
                error: null,
            };
        case ACTIONS.FEATURED_PRODUCTS_LOAD_FAILED:
            return {
                ...state,
                status: action.type,
                featuredProductsLoadError: action.data.error
            };

        case ACTIONS.PRODUCTS_LOADING:
            return {
                ...state,
                status: action.type,
            };
        case ACTIONS.PRODUCTS_LOADED:
            return {
                ...state,
                status: action.type,
                products: action.data.products,
                error: null,
            };
        case ACTIONS.PRODUCTS_LOAD_FAILED:
            return {
                ...state,
                status: action.type,
                productsLoadError: action.data.error
            };

        case ACTIONS.PRODUCT_ADDING:
            return {
                ...state,
                status: action.type,
                newProduct: action.data.newProduct
            };
        case ACTIONS.PRODUCT_ADDED:
            let newProduct = Object.assign({}, state.newProduct, {
                _id: action.data._id,
                img1: action.data.img1,
                img2: action.data.img2
            });
            return {
                ...state,
                status: action.type,
                products: [...state.products, newProduct],
                error: null,
            };
        case ACTIONS.PRODUCT_ADD_FAILED:
            return {
                ...state,
                status: action.type,
                error: action.data.error
            };
        case ACTIONS.PRODUCT_REMOVING:
            return {
                ...state,
                status: action.type,
                removingProductId: action.data._id
            };
        case ACTIONS.PRODUCT_REMOVED: {
            //-- remove the delete category
            //-- find the position of deleted product
            let index = state.products.findIndex(p => p._id === state.removingProductId);
            return {
                ...state,
                status: action.type,
                products: [
                    ...state.products.slice(0, index),
                    ...state.products.slice(index + 1)
                ],
                error: null,
            };
        }
        case ACTIONS.PRODUCT_REMOVE_FAILED:
            return {
                ...state,
                status: action.type,
                error: action.data.error
            };
        case ACTIONS.PRODUCT_UPDATING:
            return {
                ...state,
                status: action.type,
                updatingProduct: action.data
            };
        case ACTIONS.PRODUCT_UPDATED:
            //-- update new info
            let index = state.products.findIndex((c) => (c._id === state.updatingProduct._id));
            return {
                ...state,
                status: action.type,
                products: [
                    ...state.products.slice(0, index), Object.assign({}, state.products[index], state.updatingProduct, {
                        img1: action.data.img1, img2: action.data.img2
                    }), ...state.products.slice(index + 1)],
                error: null,
            };

        case ACTIONS.PRODUCT_UPDATE_FAILED:
            return {
                ...state,
                status: action.type,
                updatingProduct: action.data.statusInfo,
                error: action.data.error
            };

        case ACTIONS.PRODUCT_ORDER_SWAPPED:

            //-- update categories
            let p1Index = state.products.findIndex(p => p._id === action.data.id1);
            let p2Index = state.products.findIndex(p => p._id === action.data.id2);

            let order1 = state.products[p1Index].order;
            let order2 = state.products[p2Index].order;

            let newProducts = state.products.slice();

            newProducts = [
                ...newProducts.slice(0, p1Index),
                {
                    ...newProducts[p1Index],
                    order: order2,
                },
                ...newProducts.slice(p1Index + 1)];

            newProducts = [
                ...newProducts.slice(0, p2Index),
                {
                    ...newProducts[p2Index],
                    order: order1,
                },
                ...newProducts.slice(p2Index + 1)];

            return {
                ...state,
                status: action.type,
                products: newProducts,
            };

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/02-reducers/adminProducts.js